<template>
	<div>
		<template v-if="!newRecord">
			<table-list
				:records="mutatedJobContacts"
				:fields="$store.contactFields"
				:no-header="false"
				record-name="Contact"
				:hide-record-count="true"
				:has-delete="!readonly"
				:simple-delete="true"
				v-on:delete="removeContact">
			</table-list>
			<button v-if="!readonly" v-on:click="addContact" type="button" class="btn btn-success btn-sm float-right">
				<i class="fa fa-plus"></i>
				Add Contact
			</button>
		</template>
		<template v-else>
			<div class="form-control-plaintext"> Please SAVE the {{recordType}} first before adding contacts.</div>
		</template>

		<div style="clear: both;"></div>

		<modal-dialog
			title="Add Contact"
			:modal-visible="addContactModal.visible"
			confirm-button-text="Save"
			v-on:closeModal="addContactModal.visible = false"
			v-on:confirm="submitAddContact">

			<table-list
				v-if="'customer_id' in $store[recordType] && $store[recordType].customer_id && relatedContacts.length > 0"
				record-name="Contact"
				:fields="fields"
				:records="relatedContacts"
				:hide-record-count="true"
				:other-buttons="[
					{icon: 'fa-check',text:'select',click:'select',class:'btn-light'}
				]"
				v-on:select="selectRelatedContact">

				<h4>Contacts that belong to Customer</h4>

			</table-list>

			<contact-search-select  label="Contact"
				col-class="col-md-4"
				:individuals-only="true"
				v-model="addContactModal.payload.contact_id">
			</contact-search-select>

			<field label="Project Role" col-class="col-md-4" v-model="addContactModal.payload.role" :params="{required:true}"></field>

			<button class="btn btn-success float-right" type="button" v-on:click="newContact">
				<i class="fa fa-plus"></i>
				New Contact
			</button>
		</modal-dialog>

		<new-contact-modal 
			:visible="newCustomerModalVisible" 
			:is-company="false"
			:is-customer="false"
			v-on:closeModal="newCustomerModalVisible = false"
			v-on:contactAdded="contactAdded">
		</new-contact-modal>

	</div>
</template>

<script type="text/javascript">
import FormGroup from "../FormGroup"
import Field from "../Field"
import ContactSearchSelect from "@/components/super_components/ContactSearchSelect"
import TableList from "../TableList"
import ModalDialog from "../ModalDialog"
import NewContactModal from "./NewContactModal"

export default {
	name: "ContactTable",
	components: {
		FormGroup,
		TableList,
		ModalDialog,
		Field,
		NewContactModal,
		TableList,
		ContactSearchSelect
	},
	props: [
		"readonly",
		"recordType", //'project' or 'service'
		"contacts",
		"newRecord",
		"recordId", //id of project or service that the contact has been assigned to
		"customerId"
	],
	data() {
		return {
			addContactModal: {
				visible: false,
				payload: {},
				selectedFromRelated: false
			},
			fields: [
				{label: "Name",key: 'name'},
				{label: "Position",key: 'position'}
			],
			relatedContacts: [],
			newCustomerModalVisible: false,
			endpoint: this.recordType == 'project' ? "JobContact" : "ServiceContact",
			contactsLoading: false
		}
	},
	watch: {
		'$store.project.customer_id'() {
			if ("customer_id" in this.$store.project && this.$store.project.customer_id) 
				this.fetchRelatedContacts()
		},
		'$store.service.customer_id'() {
			if ("customer_id" in this.$store.service && this.$store.service.customer_id) 
				this.fetchRelatedContacts()
		}
	},
	computed: {
		mutatedJobContacts() {

			if (this.contacts) {

				let records = this.contacts.filter(contact => "Contact" in contact && contact.Contact).map(contact => {

					if (contact.Contact && contact.Contact) {
						contact.name = contact.Contact.name
						
						contact.phone = {
							text: contact.Contact.phone,
							link: "tel:"+contact.Contact.phone
						}

						contact.email = {
							text: contact.Contact.email,
							link: "mailto:"+contact.Contact.email
						}

						if ("Company" in contact.Contact && contact.Contact.Company)
							contact.company = contact.Contact.Company.name
						else
							contact.company = ""
					}

					contact.role = contact.role

					return contact
				})

				return records
			}
			else
				return []

		},
	},
	methods: {
		selectRelatedContact(contact) {
			let vm = this
			
			this.addContactModal.payload.role = contact.position

			let isInList = this.$store.contactsIndividuals.find(contact => contact.id == contact.id)

			if (isInList) {
				this.addContactModal.payload.contact_id = contact.id
				this.$forceUpdate()
			}
			else {
				this.getJSON("Contact/find/" + contact.slug).then(response => {
					if (response.success) {
						vm.$store.contactsIndividuals.push(response.data)
						vm.addContactModal.payload.contact_id = contact.id
						vm.$forceUpdate()
					}
				})
			}
		},
		submitAddContact() {
			
			let vm = this

			//if project is already saved, save the contacts immediately
			if (!this.newRecord) {

				//save
				let payload = {
					contact_id: this.addContactModal.payload.contact_id,
					role: this.addContactModal.payload.role
				}

				if (this.recordType == 'project') 
					payload.job_id = this.$store.project.id
				
				else 
					payload.service_id = this.$store.service.id
				

				this.saveRecord(vm.endpoint,payload, response => {
					vm.addContactModal.payload = {}

					vm.$emit("contactAdded")
					vm.addContactModal.visible = false
				})
			}
		},
		addContact() {
			//this.fetchContactIndividuals(false,50)

			this.addContactModal.visible = true
		},
		newContact() {
			let vm = this

			this.newCustomerModalVisible = true
		},
		contactAdded() {
			this.newCustomerModalVisible = false

			//this.fetchContactIndividuals(false,50)
		},
		removeContact(record) {
			let vm = this

			let filters = []
			/*
			if (this.endpoint == "JobContact")
				filters = [["job_id",this.$store.project.id],["customer_id",record.id]]
			else 
				filters = [["service_id",this.$store.service.id],["customer_id",record.id]]

			*/
			filters = [["id", record.id]]

			let params = {
				filters: filters
			}

			this.getJSON(vm.endpoint+"/get",params).then(response => {

				// Get id
				if (response.success && response.data.length > 0) {

					let promises = []

					response.data.forEach(resultRecord => {
						promises.push(vm.postData(vm.endpoint+"/delete",{id:resultRecord.id},true))
					})

					// Remove contact
					Promise.all(promises).then(responses => {
						vm.$emit("contactRemoved",record)

						//iterate jobContacts to get index, then remove the element
						if (vm.recordType == 'project') {
							vm.$store.project.JobContact.forEach((item,index) => {
								if (item.id == record.id)
									vm.$store.project.Contact.splice(index,1)
							})
						}
						else if (vm.recordType == 'service') {
							vm.$store.service.JobContact.forEach((item,index) => {
								if (item.id == record.id)
									vm.$store.service.Contact.splice(index,1)
							})
						}
					})
				}
			})

			
		},
		fetchRelatedContacts() {
			let vm = this

			let params = {
				include: [{
					model: "Contact",
					fields: ["name"]
				}]
			}

			params.filters = [["contact_id",this.$store[this.recordType].customer_id]]

			this.getJSON("Contact/get",params).then(response =>{
				if (response.success)
					vm.relatedContacts = response.data
			})
		},
	},
	created() {
		if ("customer_id" in this.$store[this.recordType] && this.$store[this.recordType].customer_id)
			this.fetchRelatedContacts()
	}
}	

</script>